import { motion } from "framer-motion";
import { Clock, FolderOpen, TrendingUp, Award } from "lucide-react";
import { useEffect, useState } from "react";

const stats = [
  {
    icon: Clock,
    value: 12847,
    suffix: "+",
    label: "Horas registradas",
    color: "bg-primary",
    iconColor: "text-primary",
  },
  {
    icon: FolderOpen,
    value: 2340,
    suffix: "+",
    label: "Projetos organizados",
    color: "bg-purple-600",
    iconColor: "text-purple-600",
  },
  {
    icon: TrendingUp,
    value: 27,
    suffix: "%",
    label: "Valor hora médio ajustado",
    color: "bg-success",
    iconColor: "text-success",
  },
  {
    icon: Award,
    value: 850,
    suffix: "+",
    label: "Freelancers ativos",
    color: "bg-warning",
    iconColor: "text-warning",
  },
];

function AnimatedStat({ value, suffix }: { value: number; suffix: string }) {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const duration = 2000;
    const steps = 60;
    const increment = value / steps;
    let step = 0;

    const timer = setInterval(() => {
      step++;
      setCurrent(Math.min(Math.floor(increment * step), value));
      if (step >= steps) clearInterval(timer);
    }, duration / steps);

    return () => clearInterval(timer);
  }, [value]);

  return (
    <span className="tabular-nums">
      {current.toLocaleString("pt-BR")}{suffix}
    </span>
  );
}

export function SocialProofSection() {
  return (
    <section className="relative py-20 sm:py-28 bg-gradient-to-b from-muted/30 to-background overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-radial from-primary/5 to-transparent rounded-full" />
      </div>

      <div className="container relative mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-wide text-foreground mb-4">
            FREELANCERS JÁ ESTÃO{" "}
            <span className="text-primary">
              ORGANIZANDO SEUS PROJETOS
            </span>
          </h2>
          <p className="text-xl text-muted-foreground">
            com o FreelaDash
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group"
            >
              <div className="relative bg-card border border-border rounded-2xl p-6 text-center hover:border-primary/30 hover:shadow-lg transition-all duration-300">
                <div className={`w-14 h-14 rounded-xl ${stat.color}/10 flex items-center justify-center mx-auto mb-4`}>
                  <stat.icon className={`h-7 w-7 ${stat.iconColor}`} />
                </div>
                
                <p className="text-3xl sm:text-4xl font-bold text-foreground mb-2">
                  <AnimatedStat value={stat.value} suffix={stat.suffix} />
                </p>
                <p className="text-muted-foreground text-sm">{stat.label}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
